export default function testScore(questions, answers) {
  let earned = 0;
  let possible = 0;

  questions.forEach(question => {
    const answer = answers[question.id] || {};
    if (question.isSubjective) {
      const lines = Math.max(1, parseInt(question.answerLines, 10) || 1);
      const grades = answer.grades || [answer.correct];
      const values = answer.answers || [];
      possible += lines;
      for (let index = 0; index < lines; index++) {
        if (values[index] && values[index].trim() && grades[index] === true) {
          earned++;
        }
      }
    } else {
      possible++;
      if (answer.correct === true) {
        earned++;
      }
    }
  });

  return possible ? ((earned / possible) * 100).toFixed(0) : '0';
}
